import { createQueryKeys } from "@lukemorales/query-key-factory";

export const amplifyAuthQueryKeys = createQueryKeys("amplifyAuth", {
  isAuthenticated: () => {
    const { $amplify } = useNuxtApp();

    return {
      queryKey: ["is-authenticated"],
      queryFn: async () => {
        if (!$amplify) {
          return false;
        }

        try {
          await $amplify.auth.getCurrentUser();

          return true;
        } catch {
          return false;
        }
      },
    };
  },
});
